<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>{{ $t(objSave.centerTitle) }}</span>
    </header-bar>
    <div class="page-content">
      <div class="ConfigInfo">
        <div class="ConfigInfo-wrapper" v-for="(ConfigInfo, index) in ConfigInfos" :key="index">
          <div class="ConfigInfo-item">
            <div></div>
            <div>{{ ConfigInfo.ConfigName }}</div>
            <SwitchOption name="switch" @click="selectConfigInfo(ConfigInfo)" v-model="ConfigInfo.ConfigValue"></SwitchOption>
          </div>
          <div v-if="ConfigInfo.ConfigValue" style="display: flex;flex-wrap: wrap;">
            <label class="ConfigInfo-status" :for="ConfigInfo.ConfigCode + ConfigStatu.CategoryCode" v-for="(ConfigStatu, index) in ConfigInfo.ConfigInfoStatus" :key="index">
              <input
                :name="ConfigInfo.ConfigCode + ConfigStatu.CategoryCode"
                :id="ConfigInfo.ConfigCode + ConfigStatu.CategoryCode"
                @change="ChangeConfigInfoStatus(ConfigInfo)"
                v-model="ConfigStatu.ConfigValue"
                :value="ConfigStatu.ConfigValue"
                type="checkbox"
              />
              <span>{{ ConfigStatu.CategoryTitle }}</span>
            </label>
          </div>
          <div class="border_bottom"></div>
        </div>
        <div class="ConfigInfo-Save" @click="Save">{{ $t("system_configinfo_configinfo_baocun") }}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .header-menu header {
    font-size: 0.452rem;
  }

  .page-content {
    background-color: #f5f5f5;
    top: 2.12rem;
  }

  .ConfigInfo-wrapper {
    padding: 0 0.266rem;
    background-color: #fff;
  }

  .ConfigInfo-item {
    position: relative;
  }

  .ConfigInfo-item > div {
    height: 1.197rem;
    line-height: 1.197rem;
  }

  .ConfigInfo-item > div:first-child {
    margin-left: 1.995rem;
  }

  .ConfigInfo-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 1.995rem; */
  }

  .ConfigInfo-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
  }

  .ConfigInfo-status {
    display: inline-block;
    width: 33%;
    text-align: left;
    box-sizing: border-box;
    /* margin-right: 0.665rem; */
    /* margin-top: 0.133rem; */
    border-radius: 0.03rem;
    padding: 0.212rem 0;
  }

  .ConfigInfo-status span {
    vertical-align: middle;
  }

  .ConfigInfo-status input {
    vertical-align: middle;
  }

  .ConfigInfo-Save {
    background-color: #12a3ff;
    color: #fff;
    text-align: center;
    line-height: 1.064rem;
    height: 1.064rem;
    border-radius: 0.106rem;
    width: 7.98rem;
    margin: 0.798rem auto 0.798rem auto;
  }
</style>

<script>
  import SwitchOption from "../modules/switch-option.vue";
  import navBar from "../modules/navBar.vue";
  import UserService from "@/service/UserService";
  export default {
    data() {
      return {
        objSave: {
          centerTitle: this.$root.$t("system_configinfo_configinfo_peizhiguanli"),
        },
        ConfigInfos: [
          {
            ConfigValue: false,
            ConfigInfoStatus: [],
            ConfigCode: "Email",
            ConfigName: this.$root.$t("system_configinfo_configinfo_youxiang"),
          },
          {
            ConfigValue: false,
            ConfigInfoStatus: [],
            ConfigCode: "Wechat",
            ConfigName: this.$root.$t("system_configinfo_configinfo_weixin"),
          },
          // , {
          //     ConfigValue: false,
          //     ConfigInfoStatus: [],
          //     ConfigCode: 'SMS',
          //     ConfigName: '短信',
          // }, {
          //     ConfigValue: false,
          //     ConfigInfoStatus: [],
          //     ConfigCode: 'APPClient',
          //     ConfigName: '客户端',
          // }
        ],
        ConfigStatus: [
          { ConfigValue: false, CategoryTitle: this.$root.$t("system_configinfo_configinfo_daishenpi"), CategoryCode: "WaitApprove" },
          { ConfigValue: false, CategoryTitle: this.$root.$t("system_configinfo_configinfo_daiqueren"), CategoryCode: "WaitConfirm" },
          { ConfigValue: false, CategoryTitle: this.$root.$t("system_configinfo_configinfo_daizhifu"), CategoryCode: "WaitPayment" },
          { ConfigValue: false, CategoryTitle: this.$root.$t("system_configinfo_configinfo_daichuli"), CategoryCode: "WaitDispose" },
          { ConfigValue: false, CategoryTitle: this.$root.$t("system_configinfo_configinfo_yiwancheng"), CategoryCode: "Finished" },
        ],
        lists: [],
      };
    },
    computed: {
      UserID() {
        return this.profile.UserID;
      },
    },
    mounted() {
      let __self = this;
      __self.__init();
    },
    methods: {
      __init() {
        let __self = this;
        let data = {
          RoleID: __self.UserID,
        };
        UserService.getConfigList(data).then(json => {
          if (json.isSucc) {
            let results = json.result;
            __self.ConfigInfos.forEach(m => {
              let list = _.find(results, n => {
                return n.ConfigCode == `Role.Notify.${m.ConfigCode}`;
              });
              if (list) {
                if (list.ConfigValue == "1150") {
                  m.ConfigValue = true;
                } else {
                  m.ConfigValue = false;
                }
                m.ConfigInfoStatus = _.cloneDeep(__self.ConfigStatus);
                m.ConfigInfoStatus.forEach(o => {
                  let result = _.find(results, n => {
                    return `Role.Notify.${m.ConfigCode}.OrderStatus.${o.CategoryCode}` == n.ConfigCode;
                  });
                  if (result) {
                    if (result.ConfigValue == "1150") {
                      o.ConfigValue = true;
                    } else {
                      o.ConfigValue = false;
                    }
                  } else {
                    o.ConfigValue = true;
                  }
                });
              }
            });
            __self.lists = results;
          }
        });
      },
      selectConfigInfo(ConfigInfo) {
        let __self = this;
        ConfigInfo.ConfigInfoStatus = _.cloneDeep(__self.ConfigStatus);
        if (!ConfigInfo.ConfigValue) {
          ConfigInfo.ConfigInfoStatus.forEach(o => {
            o.ConfigValue = true;
          });
        } else {
          ConfigInfo.ConfigInfoStatus = [];
        }
      },
      ChangeConfigInfoStatus(config) {
        let Count = _.countBy(config.ConfigInfoStatus, "ConfigValue");
        if (Count.false == 5) {
          config.ConfigValue = false;
        }
      },
      Save() {
        let __self = this;
        let lists = [];
        __self.ConfigInfos.forEach(o => {
          let list = {
            ConfigCode: "Role.Notify." + o.ConfigCode,
          };
          if (o.ConfigValue && o.ConfigInfoStatus.length > 0) {
            let Count = _.countBy(o.ConfigInfoStatus, "ConfigValue");
            if (Count.true != 5) {
              o.ConfigInfoStatus.forEach(m => {
                if (!m.ConfigValue) {
                  lists.push({
                    ConfigCode: `Role.Notify.${o.ConfigCode}.OrderStatus.${m.CategoryCode}`,
                    ConfigValue: m.ConfigValue ? "1150" : "1151",
                    RoleID: __self.UserID,
                    ConfigID: o.ConfigID,
                  });
                }
              });
            }
          }
          lists.push({
            ConfigCode: "Role.Notify." + o.ConfigCode,
            ConfigValue: o.ConfigValue ? "1150" : "1151",
            RoleID: __self.UserID,
            ConfigID: o.ConfigID,
          });
        });

        lists.forEach(o => {
          let data = _.find(__self.lists, m => {
            return o.ConfigCode == m.ConfigCode;
          });
          if (data) {
            o.ConfigID = data.ConfigID;
          } else {
            o.ConfigID = "";
          }
        });
        UserService.saveConfigInfo(lists).then(json => {
          if (json.isSucc) {
            this.$root.$toast.success(this.$root.$t("system_configinfo_configinfo_baocunchenggong"), "succ");
            __self.__init();
          }
        });
      },
    },
    components: {
      navBar,
      SwitchOption,
    },
  };
</script>
